import React from "react";
import {
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Typography,
  Box,
  Divider,
  Chip,
} from "@mui/material";

import { FeedbackQuestions as questions } from "./FeedbackQuestions";
import useFeedbackStore from "./../../store/FeedbackStore";
const FeedbackForm = ({ closeHandler }) => {
  const { feedback, setFeedback, submitFeedback } = useFeedbackStore();
  const [errors, setErrors] = React.useState({});

  const handleRadioChange = (event, questionId) => {
    setFeedback(questionId, event.target.value);
    if (errors[questionId]) {
      setErrors((prev) => ({ ...prev, [questionId]: false }));
    }
  };

  const handleCommentChange = (event, questionId) => {
    setFeedback(`${questionId}-comments`, event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let newErrors = {};
    questions.forEach((question) => {
      if (!feedback[question.id]) {
      }
    });
    if (Object.keys(newErrors).length === 0) {
      const response = await submitFeedback();
      if (response) {
        closeHandler();
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <Box display={"flex"} flexDirection={"column"} gap={6}>
      <Typography variant="title">Feedback</Typography>
      <form onSubmit={handleSubmit}>
        {questions.map((question) => (
          <Box key={question.id} sx={{ marginBottom: 6 }}>
            <FormControl component="fieldset" error={errors[question.id]}>
              <FormLabel component="legend">{question.label}</FormLabel>
              <RadioGroup
                name={question.id}
                value={feedback[question.id] || ""}
                onChange={(event) => handleRadioChange(event, question.id)}
              >
                {question.options.map((option, index) => (
                  <FormControlLabel
                    key={index}
                    value={option}
                    control={<Radio />}
                    label={option}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            <Box display={"flex"} gap={"12px"} flexDirection={"column"} mt={4}>
              <Typography>Comments</Typography>

              <TextField
                fullWidth
                multiline
                maxRows={4}
                value={feedback[`${question.id}-comments`] || ""}
                onChange={(event) => handleCommentChange(event, question.id)}
                sx={{ backgroundColor: "#fff" }}
              />
            </Box>

            <Divider sx={{ marginTop: 6 }} />
          </Box>
        ))}

        <Chip
          label="Submit"
          onClick={handleSubmit}
          color="primary"
          variant="filled"
          sx={{ cursor: "pointer", mt: 2 }}
        />
      </form>
    </Box>
  );
};

export default FeedbackForm;
